jQuery(document).ready(function($){

  var windowWidth = $(window).width();
  var windowHeight = $(window).height();

  $(window).resize(function() {
    if(windowWidth != $(window).width() || windowHeight != $(window).height()) {
      location.reload();
      return;
    }
  });

  // Add offset for sticky nav on homepage
	if ($('body.home').length > 0) {
		$('body.home').parents('html').css('scroll-padding-top', '65px');
	}
		
	$('.wp-block-navigation__responsive-container-open').on('click', function(e){
	  $(this).hide();
	});

	$('.wp-block-navigation__responsive-container-close').on('click', function(){
		$('.wp-block-navigation__responsive-container-open').show();
	});

	$('.slider-wheel-slides').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	  fade: false,
	  centerMode: true,
	  centerPadding: '10%',
	  asNavFor: '.slider-wheel-nav-slides',
	  prevArrow: $('.prev'),
		nextArrow: $('.next'),
	  responsive: [
    {
      breakpoint: 1400,
      settings: {
      	centerMode: true,
        centerPadding: '5%',
      }
    },
    {
      breakpoint: 991,
      settings: {
        centerMode: false
      }
    }
  ]
	});

	$('.slider-wheel-nav-slides').slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  asNavFor: '.slider-wheel-slides',
	  dots: false,
	  arrows: false,
	  centerMode: true,
	  focusOnSelect: true
	});

	$('.slider-wheel-nav-slides').on('click', 'li.inner', function(){
	  var idx = Number($(this).data('index'));
	  $('.slider-wheel-slides').slick('slickGoTo', idx);
	});

	// set active class to facet filter
  function getParam(name) {
    return (new URLSearchParams(window.location.search)).get(name);
  };

	var correctAnswer = '';
	$('.quiz-answer-row').hide();

	$('input').on('click', function(){
		//when radio button selected, drop down answer and disable input
		if ( $( this ).is(':checked') ){
			$( this ).parents('.quiz-row').find('.quiz-answer-row').slideDown();
			$( this ).parents('.quiz-tf').find('input').prop('disabled', true);
		}

		//establish if the user selected the correct answer
		//in single-quiz.php, class is added depending on if answer is true/false
		if ( $( this ).parents('.alt-colors').length ){
			correctAnswer = 'false';
		} else {
			correctAnswer = 'true'
		}

		//adds alternating highlighter color
		if ( $( this ).is(':checked') && $( this ).parents('.alt-colors').length ){
			$( this ).parents('.quiz-row').find('.quiz-question').addClass('blue');
		} else {
			$( this ).parents('.quiz-row').find('.quiz-question').addClass('yellow');
		}

		// adds o to correct answer
		if ( $( this ).parents('.alt-colors').length && $( this ).val() === correctAnswer ){
			$( this ).siblings('.result').addClass('circle');
		} else if ( $( this ).val() === correctAnswer ) {
			$( this ).siblings('.result').addClass('circle');
		}

		//adds x for incorrect answer
		if ( $( this ).parents('.alt-colors').length && $( this ).val() != correctAnswer ){
			$( this ).siblings('.result').css({
				"border": "none",
				"background": "linear-gradient(45deg, transparent 0%,transparent 47.5%,#89DDFF 47.5%,#89DDFF 55%,transparent 55%,transparent 100%), linear-gradient(135deg, transparent 0%,transparent 47.5%,#89DDFF 47.5%,#89DDFF 55%,transparent 55%,transparent 100%)"
			});
		} else if ( $( this ).val() != correctAnswer ) {
			$( this ).siblings('.result').css({
				"border": "none",
				"background": "linear-gradient(45deg, transparent 0%,transparent 47.5%,#FBE28B 47.5%,#FBE28B 55%,transparent 55%,transparent 100%), linear-gradient(135deg, transparent 0%,transparent 47.5%,#FBE28B 47.5%,#FBE28B 55%,transparent 55%,transparent 100%)"
			});
		}
	});

	var filter = getParam('filter');
  if (!filter) return;

  var $match = $('a.video-category[href="?filter=' + filter + '"]');

  if ($match.length) {
    $('a.video-category').removeClass('active');
    $match.addClass('active');
  };

	var pauseVideo = function(){
		var total = $('.video-item').length;

		for( let i = 1; i <= total; i++ ){
			$('#video-next-' + i).click(function(){
				$('#video-iframe-' + i)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			})
		}
	}

	var init = function () {
		pauseVideo();
	};

	return {
		init:init
	};

	if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  	$('.nav-link').click(function(){
		$("#navbarNavDropdown").removeClass("show");
	  $("button.navbar-toggler").addClass("collapsed");
	  $("button.navbar-toggler").attr("aria-expanded","false");
	});

  } else {

  	//open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})
  }
  document.addEventListener("DOMContentLoaded", function () {
	  const mybutton = document.getElementById("btt");

	  if (mybutton) {
	    // Show/hide on scroll
	    window.addEventListener("scroll", function () {
	      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	        mybutton.style.display = "block";
	      } else {
	        mybutton.style.display = "none";
	      }
	    });

	    // Scroll to top on click
	    mybutton.addEventListener("click", function () {
	      document.body.scrollTop = 0; // For Safari
	      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	    });
	  }
	});


  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);

	})

	$(document).on('facetwp-loaded', function() {
    $('.facetwp-facet-search .facetwp-icon').hide();
    $('.facetwp-facet-search .facetwp-input-wrap').each(function() {
        if ($(this).find('.facetwp-search-submit').length < 1) {
            $(this).find('.facetwp-search').after('<button class="facetwp-search-submit" onclick="FWP.refresh()">Search</button>');
        }
    });
	});

	// Lightbox initialization
	if (typeof GLightbox !== 'undefined') {
		GLightbox({ selector: '.video-lightbox' });
	}

	// Slick slider initialization
	$('.video-slider').each(function () {
		const $slider = $(this);
		const slideCount = $slider.find('.video-slide').length;

		$slider.slick({
			dots: false,
			arrows: slideCount > 1, // disable arrows if only one slide
			prevArrow: $('.slick-prev'),
			nextArrow: $('.slick-next'),
			adaptiveHeight: true
		});
	});


    // Play button overlay handler
    $('.play-button-overlay').on('click', function () {
	    const wrapper = $(this).closest('.video-slide');
	    const video = wrapper.find('video').get(0);

	    if (video) {
	        video.setAttribute('controls', true);
	        video.play();
	    }

	    $(this).fadeOut();
	});


	// Pause videos and show overlays when slide changes
	$('.video-slider').on('beforeChange', function () {
	    $('.video-player').each(function () {
	        this.pause();
	        this.removeAttribute('controls');
	        this.currentTime = 0;
	    });
	    $('.play-button-overlay').fadeIn();
	});

	// Click poster to play and hide overlay
	$('.video-slide video').on('play', function () {
		$(this).siblings('.play-button-overlay').fadeOut();
	});
});

// fix for smooth scroll issue
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        // Teleport instantly close to trigger lazy loading, then smooth scroll the rest
        const topPos = targetElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: topPos - 200, behavior: 'auto' });
        
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    });
  });
});